import type { CompanyRef } from '@gat-ship/types'
import { getCompanyRefsRequest } from '../model/company-api-calls'
import { createListRefDataSource } from './create-list-ref-datasource'

/** Shared company ref cache for select/combobox pickers. */
export const companyRefDataSource = createListRefDataSource<CompanyRef>({
  fetch: getCompanyRefsRequest,
  debounceMs: 0
})
